export const PAYMENT_PROVIDER_LINKS = Object.freeze({
  paywaySignup: "https://mi.payway.com.ar/ms/ui-login/onboarding/cuit",
  paywayOnlineOnboarding: "https://ventasonline.payway.com.ar/onboarding/",
  paywayOnlinePortal: "https://ventasonline.payway.com.ar/sac/LoginServlet",
  paywaySupport: "https://www.payway.com.ar/contacto",
  modoDocs: "https://merchants.modo.com.ar/docs/",
  modoSupport: "https://www.modo.com.ar/ayuda/preguntas-frecuentes/C%C3%B3mo-instalo-MODO-en-Woocommerce-Magento-o-v%C3%ADa-API",
  modoCredentialsV2: "https://play-sistemico.atlassian.net/wiki/spaces/Developers/pages/5904924673/V2+Credenciales+de+integraci+n",
  modoCommercialConditions: "https://merchants.modo.com.ar/docs/6c3328bb-2fce-40b0-a71c-ba48b1490e9d",
});
